export default __webpack_public_path__ + "static/media/arrow-up.78ef0ada.svg";